import React from 'react';

import { array, func, string } from 'prop-types';
import { useFormatMessage } from 'react-intl-hooks';

import { Button, InputSearch, Select } from '@seekube/ui-kit';

import { CustomOption } from '../CustomOption/CustomOption';
import styles from './styles.less';

const Mobile = ({
  selected,
  onChange,
  search,
  onSearch,
  searchHits,
  contractsSelected,
  setContractsSelected,
  contractOptions,
  localisationSelected,
  setLocalisationSelected,
  localisationOptions,
  handleLocalisationSearchChange,
  handleSearchEvents,
}) => {
  const t = useFormatMessage();

  const isOptionSelected = (options, opt) => options.includes(opt.value);

  const renderOption = (
    options,
    opt,
    { key, onClick, onSelect, active } = {},
    withCheckbox = false,
  ) => {
    const isSelected = withCheckbox && isOptionSelected(options, opt);

    return (
      <CustomOption
        withCheckbox={withCheckbox}
        disabled={parseInt(opt.count, 10) === 0 && !isSelected}
        opt={opt}
        onSelect={onSelect || onClick}
        id={key}
        selected={withCheckbox && isSelected}
        active={active}
      />
    );
  };

  return (
    <div className={styles.search}>
      <form className={styles.content} onSubmit={e => e.preventDefault()}>
        <div className={styles.customSearch}>
          <InputSearch
            autocomplete
            search={search}
            onChange={onChange}
            value={selected}
            onSearch={onSearch}
            name="job"
            id="job"
            label={t({ id: 'searchEngine.keywords.label' })}
            required={false}
            className={styles.input}
            options={searchHits}
            renderOption={(opt, { key, onClick, active }) =>
              renderOption(null, opt, { key, active, onClick }, false)
            }
          />
        </div>
        <div className={styles.customSelect}>
          <Select
            name="searchEngine.contracts"
            id="searchEngine.contracts"
            value={contractsSelected}
            onChange={setContractsSelected}
            label={t({ id: 'searchEngine.contracts.label' })}
            required={false}
            options={contractOptions}
            multiple
            showCounter
            className={styles.selectLeft}
            renderOption={(opt, { key, onSelect }) =>
              renderOption(contractsSelected, opt, { key, onSelect }, true)
            }
          />
        </div>
        <div className={`${styles.customSearch} ${styles.noBorderRadius}`}>
          <InputSearch
            name="searchEngine.localisation"
            id="searchEngine.localisation"
            leftIcon={false}
            value={localisationSelected}
            onChange={setLocalisationSelected}
            onSearch={handleLocalisationSearchChange}
            label={t({ id: 'searchEngine.localisation.label' })}
            required={false}
            options={localisationOptions}
            autocomplete
            className={styles.selectRight}
          />
        </div>
      </form>
      <Button type="submit" onClick={handleSearchEvents} className={styles.customSearchBtn}>
        {t({ id: 'search' })}
      </Button>
    </div>
  );
};

Mobile.propTypes = {
  selected: string,
  search: string,
  onChange: func,
  onSearch: func,
  selectedSearch: func,
  setSelectedSearch: func,
  inputSearch: string,
  setInputSearch: func,
  searchHits: array,
  contractsSelected: array,
  setContractsSelected: func,
  contractOptions: array,
  localisationSelected: string,
  setLocalisationSelected: func,
  localisationOptions: array,
  handleLocalisationSearchChange: func,
  handleSearchEvents: func,
};

export { Mobile };
